import React from "react";
import CreateRequirementResultSubDialog from "features/requirements/components/CreateRequirementResultSubDialog";
import { RequirementResultDialogParams, ResultDialogButtonLink } from 'features/requirements/models/RequirementResultDialogParams';
import ResultDialogButton from "features/requirements/components/ResultDialogButton";
import { Nullable } from "features/shared/types/nullable";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import ContentDialogService from "features/shared/components/contentDialog/ContentDialogService";
import i18n from "infrastructure/localization/i18n";

export const openRequirementResultDialog = (useOutsideOfRequirements: boolean, params: RequirementResultDialogParams, title?: string, forceMessages?: boolean) => {
  const dialogService = inversifyContainer.get<ContentDialogService>(IocTypes.ContentDialogService);

  if (useOutsideOfRequirements) {
    dialogService.openDialog(`${title}`, () =>  renderRequirementResultDialog(params), false);
  } else {
    dialogService.openDialog(
      // funkce predpoklada, ze jsou preklady pro namespace shared\\moduleNames jiz nactene
      // https://github.com/i18next/react-i18next/issues/909#issuecomment-514604843
      i18n.t("requirementCreate.title", { ns: "shared\\moduleNames" }),
      () =>
        renderRequirementResultDialog({
          response: params.response,
          errorMessage: forceMessages ? params.errorMessage : undefined,
          successMessage: forceMessages ? params.successMessage : undefined,
          moreInfoMessage: forceMessages ? params.moreInfoMessage : undefined,
        }),
      false
    );
  }
};

export const renderRequirementResultDialog = (params: RequirementResultDialogParams): JSX.Element => {
  return (
    <CreateRequirementResultSubDialog
      responseStatus={params.response.status}
      result={params.response.data}
      successMessage={params.successMessage}
      errorMessage={params.errorMessage}
      moreInfoMessage={params.moreInfoMessage}
      renderActionBtn={renderResultDialogBtn(params.actionBtn)}
      renderTransitionBtn={renderResultDialogBtn(params.transitonBtn, true)}
    />
  );
}

const renderResultDialogBtn = (link: Nullable<ResultDialogButtonLink> | undefined, isTransitonBtn = false) => {
  if (link) {
    return () => (
      <ResultDialogButton
        title={link.title}
        route={link.route}
        colorSuffix={isTransitonBtn ? "secondary" : undefined}
        className={isTransitonBtn ? "mr-2" : undefined}
        isOutline={isTransitonBtn}
      />
    );
  } else if (link === null) {
    return () => <></>
  }
}